import {
  Field,
  FieldArray,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import React, { useEffect, useRef, useState } from "react";
import ShadowCard from "../../components/common/ShadowCard";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { Typography } from "@progress/kendo-react-common";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { Button } from "@progress/kendo-react-buttons";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import FormDatePicker from "../../components/formFields/FormDateField";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import moment from "moment";
import { RootState } from "../../app/store";
import {
  getKarigarListByProcess,
  getKarigarStock,
} from "../karigar/services/karigar.services";
import { LoadingPanel } from "../../components/layout/Loading";
import { IKarigarListByProcess } from "../karigar/karigarModel";
import { findAllActiveItem } from "../item/services/item.services";
import { createDull, getDullById, updateDull } from "./services/dull.services";
import { findAllActiveProcess } from "../process/services/process.services";
import { clearDullDetail } from "./dullSlice";
import DullOrderItemArray from "./DullOrderItemArray";
import { ErrorToast } from "../../components/toast/Toasts";
import { clearOrderDetail } from "../order/orderSlice";
import { findAllOrder } from "../order/services/order.services";
import { PRINT_ACCESS, PROCESS_ID } from "../../_contstants/common";
import { clearKarigarStock } from "../karigar/karigarSlice";
import {
  checkAcessRights,
  formatToIndianCurrencyWithoutSymbol,
  formatWeight,
} from "../../_helper/helper";
import { FaEye } from "react-icons/fa";

interface FormChangeWatcherProps {
  formRenderProps: FormRenderProps;
}
const KarigarChangeWatcher: React.FC<FormChangeWatcherProps> = ({
  formRenderProps,
}) => {
  const dispatch = useAppDispatch();
  const karigar_id = formRenderProps.valueGetter("karigar_id");
  const fetchKarigarStock = async (karigar_id: number) => {
    await dispatch(getKarigarStock(karigar_id));
  };
  useEffect(() => {
    if (karigar_id) {
      fetchKarigarStock(karigar_id);
    }
  }, [karigar_id]);

  return null;
};

const CreateDull: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);
  const dull_issue_guid = location?.state?.dull_issue_guid;

  const loading = useAppSelector((state) => state.dull?.loading);
  const KarigarListByProcess = useAppSelector(
    (state) => state.karigar?.KarigarListByProcess,
  );
  const karigarStock = useAppSelector((state) => state.karigar.KarigarStock);
  const DullDetail = useAppSelector(
    (state: RootState) => state.dull.DullDetail,
  );
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);
  const FilterOrder = useAppSelector((state) => state.order.FilterOrder);
  const isPrintAccess = checkAcessRights(
    "/" + location.pathname.split("/")[1],
    PRINT_ACCESS,
  );
  const [formKey, setFormKey] = useState(1);

  useEffect(() => {
    dispatch(getKarigarListByProcess(PROCESS_ID.dull));
    dispatch(findAllActiveItem());
    dispatch(findAllActiveProcess());
    return () => {
      dispatch(clearDullDetail());
      dispatch(clearOrderDetail());
      dispatch(clearKarigarStock());
    };
  }, []);

  useEffect(() => {
    const payload = {
      ...FilterOrder,
      limit: +pageLimit,
      skip: +currentPage * +pageLimit,
      ProcessID: PROCESS_ID.dull,
    };
    dispatch(findAllOrder(payload));
  }, [currentPage, pageLimit]);

  useEffect(() => {
    if (dull_issue_guid) {
      dispatch(getDullById(dull_issue_guid));
    }
  }, [dull_issue_guid]);
  useEffect(() => {
    setFormKey(formKey + 1);
  }, [DullDetail]);

  const handleSubmit = async (values: any) => {
    if (values.dull_issue_order?.length === 0) {
      ErrorToast("At least One Order is Required !");
      return false;
    }
    const formData = {
      karigar_id: values.karigar_id ? +values.karigar_id : 0,
      issue_date: values.issue_date
        ? moment(values.issue_date).format("YYYY-MM-DD")
        : "",
      approx_delivery_date: values.approx_delivery_date
        ? moment(values.approx_delivery_date).format("YYYY-MM-DD")
        : "",
      dull_issue_order: values.dull_issue_order
        ? values.dull_issue_order.map((dullOrder: any) => {
            return {
              id: dullOrder.id ? dullOrder.id : 0,
              previous_process_id: dullOrder.previous_process_id
                ? +dullOrder.previous_process_id
                : null,
              order_id: dullOrder.order_id ? +dullOrder.order_id : null,
              item_id: dullOrder.item_id ? +dullOrder.item_id : null,
              item_description: dullOrder.item_description
                ? dullOrder.item_description
                : "",
              weight: dullOrder.weight ? dullOrder.weight : null,
              remarks: dullOrder.remarks ? dullOrder.remarks : "",
            };
          })
        : [],
    };
    if (dull_issue_guid) {
      const editPayload = {
        dull_issue_guid: dull_issue_guid,
        dull_issue_no: values.dull_issue_no,
        ...formData,
      };
      try {
        const response = await dispatch(updateDull(editPayload));
        if (response?.meta?.requestStatus === "fulfilled") {
          navigate("/dull");
        }
      } catch (error) {
        console.error("Error in handleSubmit:", error);
        throw error;
      }
    } else {
      try {
        const response = await dispatch(createDull(formData));
        if (response?.meta?.requestStatus === "fulfilled") {
          navigate("/dull");
        }
      } catch (error) {
        console.error("Error in handleSubmit:", error);
        throw error;
      }
    }
  };
  const handleFormClose = () => {
    navigate("/dull");
  };

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      <Form
        onSubmit={handleSubmit}
        key={formKey}
        initialValues={DullDetail}
        render={(formRenderProps: FormRenderProps) => (
          <FormElement>
            <KarigarChangeWatcher formRenderProps={formRenderProps} />
            <ShadowCard style={{ padding: 12 }}>
              <GridLayout
                style={{ marginRight: 20 }}
                gap={{ rows: 0, cols: 10 }}
                cols={[
                  { width: "33.33%" },
                  { width: "33.33%" },
                  { width: "33.33%" },
                ]}
              >
                <GridLayoutItem colSpan={3}>
                  <Typography.h4>
                    {dull_issue_guid
                      ? "Update Dull Issue"
                      : "Create Dull Issue"}
                  </Typography.h4>
                </GridLayoutItem>
                <GridLayoutItem colSpan={3}>
                  {dull_issue_guid ? (
                    <Typography.h5>
                      Dull No :{" "}
                      <span style={{ color: "green" }}>
                        {DullDetail.dull_issue_no}
                      </span>
                    </Typography.h5>
                  ) : (
                    ""
                  )}
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="karigar_id"
                    label="Karigar Name"
                    placeholder="Select Karigar"
                    isAddNew={true}
                    addNewLink="karigar/create"
                    dispatcherFunction={getKarigarListByProcess}
                    dispatcherFunctionPayload={PROCESS_ID.dull}
                    component={FormSelectionField}
                    validator={requiredValidator}
                    astrike={true}
                    options={KarigarListByProcess?.map(
                      (karigar: IKarigarListByProcess) => {
                        return {
                          value: karigar?.karigar_id,
                          label: `${karigar?.karigar_nick_name || karigar?.karigar_name}`,
                        };
                      },
                    )}
                  />
                </GridLayoutItem>
                <GridLayoutItem style={{ display: "flex", gap: 10 }}>
                  <Field
                    wrapperStyle={{ width: "100%" }}
                    name="issue_date"
                    label="Issue Date"
                    placeholder="day/month/year"
                    format={"dd/MM/yyyy"}
                    component={FormDatePicker}
                    validator={requiredValidator}
                    astrike={true}
                  />
                  <Field
                    wrapperStyle={{ width: "100%" }}
                    name="approx_delivery_date"
                    label="Approx Delivery Date"
                    format={"dd/MM/yyyy"}
                    placeholder="day/month/year"
                    component={FormDatePicker}
                    validator={requiredValidator}
                    astrike={true}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <div className="stock-container">
                    <div className="stock-item">
                      <div className="stock-header">
                        <div
                          className={`indicator-dot amount-dot-${karigarStock.Amount_credit_debit}`}
                        ></div>
                        <Typography.h6 className="stock-label">
                          Amount Balance
                        </Typography.h6>
                      </div>
                      <Typography.h6
                        className={`stock-value amount-value-${karigarStock.Amount_credit_debit}`}
                      >
                        {formatToIndianCurrencyWithoutSymbol(
                          karigarStock.amount || 0,
                        )}{" "}
                        <span
                          style={{
                            fontWeight: "normal",
                            textTransform: "capitalize",
                            fontSize: 16,
                          }}
                        >
                          {karigarStock.Amount_credit_debit}
                        </span>
                      </Typography.h6>
                    </div>

                    <div className="stock-item">
                      <div className="stock-header">
                        <div
                          className={`indicator-dot phine-dot-${karigarStock.phine_credit_debit}`}
                        ></div>
                        <Typography.h6 className="stock-label">
                          Phine (gm) Stock
                        </Typography.h6>
                      </div>
                      <Typography.h6
                        className={`stock-value phine-value-${karigarStock.phine_credit_debit}`}
                      >
                        {formatWeight(karigarStock.phine)}{" "}
                        <span
                          style={{
                            fontWeight: "normal",
                            textTransform: "capitalize",
                            fontSize: 16,
                          }}
                        >
                          {karigarStock.phine_credit_debit}
                        </span>
                      </Typography.h6>
                    </div>
                  </div>
                </GridLayoutItem>
              </GridLayout>
            </ShadowCard>
            <ShadowCard style={{ marginTop: 10 }}>
              <GridLayout cols={[{ width: "100%" }]}>
                <GridLayoutItem>
                  <Typography.h4>Dull Orders</Typography.h4>
                </GridLayoutItem>
                <GridLayoutItem>
                  <FieldArray
                    formRenderProps={formRenderProps}
                    component={DullOrderItemArray}
                    name="dull_issue_order"
                  />
                </GridLayoutItem>
                <GridLayoutItem
                  style={{
                    textAlign: "end",
                    marginTop: "20px",
                    width: "100%",
                  }}
                >
                  {isPrintAccess && dull_issue_guid && (
                    <Button
                      type="button"
                      style={{ marginRight: 4 }}
                      fillMode={"solid"}
                      themeColor={"primary"}
                      onClick={() =>
                        window.open(`/dullissue/${dull_issue_guid}`, "_blank")
                      }
                    >
                      <FaEye style={{ fontSize: "18" }} /> View Report
                    </Button>
                  )}
                  <ButtonWithLoading
                    label={!dull_issue_guid ? "Create" : "Update"}
                    type="submit"
                    disabled={!formRenderProps.allowSubmit || loading}
                    loading={loading}
                  />
                  <Button
                    type="button"
                    fillMode={"outline"}
                    themeColor={"primary"}
                    style={{ marginLeft: 4 }}
                    onClick={handleFormClose}
                  >
                    Cancel
                  </Button>
                </GridLayoutItem>
              </GridLayout>
            </ShadowCard>
          </FormElement>
        )}
      />
    </>
  );
};

export default CreateDull;
